/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetZReport200ResponseMoneyEarnedLinesInner
 */
export interface GetZReport200ResponseMoneyEarnedLinesInner {
    /**
     * 
     * @type {string}
     * @memberof GetZReport200ResponseMoneyEarnedLinesInner
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof GetZReport200ResponseMoneyEarnedLinesInner
     */
    total: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetZReport200ResponseMoneyEarnedLinesInner
     */
    values: Array<number>;
}

/**
 * Check if a given object implements the GetZReport200ResponseMoneyEarnedLinesInner interface.
 */
export function instanceOfGetZReport200ResponseMoneyEarnedLinesInner(value: object): value is GetZReport200ResponseMoneyEarnedLinesInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('values' in value) || value['values'] === undefined) return false;
    return true;
}

export function GetZReport200ResponseMoneyEarnedLinesInnerFromJSON(json: any): GetZReport200ResponseMoneyEarnedLinesInner {
    return GetZReport200ResponseMoneyEarnedLinesInnerFromJSONTyped(json, false);
}

export function GetZReport200ResponseMoneyEarnedLinesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetZReport200ResponseMoneyEarnedLinesInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'total': json['total'],
        'values': json['values'],
    };
}

export function GetZReport200ResponseMoneyEarnedLinesInnerToJSON(json: any): GetZReport200ResponseMoneyEarnedLinesInner {
    return GetZReport200ResponseMoneyEarnedLinesInnerToJSONTyped(json, false);
}

export function GetZReport200ResponseMoneyEarnedLinesInnerToJSONTyped(value?: GetZReport200ResponseMoneyEarnedLinesInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'total': value['total'],
        'values': value['values'],
    };
}

